import { styled } from 'goober';
import { useTranslation } from 'react-i18next';

import { Stack } from '@/ui/line/line';

import type { FeedTab } from './feed.state';

export const FeedTabHeader = ({ tab }: { tab: FeedTab }) => {
  const { t } = useTranslation('feed', { keyPrefix: 'tabContent' });

  return (
    <Header data-testid={`feed-tab-header-${tab}`}>
      <Stack gap="4px">
        <Title>{t(`${tab}.title`)}</Title>
        <Description>{t(`${tab}.description`)}</Description>
      </Stack>
    </Header>
  );
};

const Header = styled('header')`
  margin-bottom: 24px;
`;

const Title = styled('h1')`
  ${({ theme }) => theme.typography.feed.tabTitle}
  margin: 0;
`;

const Description = styled('p')`
  ${({ theme }) => theme.typography.feed.tabDescription}
  margin: 0;
`;
